import "./footer.css";
import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">Copyright 2020 Argent Bank</p>
    </footer>
  );
}

export default Footer;
